import React from 'react'

import { CheckboxGroup } from '../checkbox-group/CheckboxGroup'
import { Tree } from '../tree/Tree'
import { CheckboxTreeCollapsible } from './CheckboxTreeCollapsible'
import { CheckboxTreeCollapsibleContent } from './CheckboxTreeCollapsibleContent'
import { CheckboxTreeCollapsibleTrigger } from './CheckboxTreeCollapsibleTrigger'
import { CheckboxTreeItem } from './CheckboxTreeItem'

type CheckboxTreeRootProps = Omit<
  React.ComponentProps<typeof CheckboxGroup> &
    React.ComponentProps<typeof Tree>,
  'asChild'
>

export const CheckboxTreeRoot = ({
  checked,
  defaultChecked,
  onCheckedChange,
  ...rest
}: CheckboxTreeRootProps): React.ReactElement<unknown> => {
  const checkboxGroupProps = { checked, defaultChecked, onCheckedChange }
  return (
    <CheckboxGroup {...checkboxGroupProps} asChild>
      <Tree {...rest} />
    </CheckboxGroup>
  )
}

type CheckboxTreeType = typeof CheckboxTreeRoot & {
  Collapsible: typeof CheckboxTreeCollapsible
  CollapsibleContent: typeof CheckboxTreeCollapsibleContent
  CollapsibleTrigger: typeof CheckboxTreeCollapsibleTrigger
  Item: typeof CheckboxTreeItem
}

export const CheckboxTree: CheckboxTreeType = Object.assign(CheckboxTreeRoot, {
  Collapsible: CheckboxTreeCollapsible,
  CollapsibleContent: CheckboxTreeCollapsibleContent,
  CollapsibleTrigger: CheckboxTreeCollapsibleTrigger,
  Item: CheckboxTreeItem
})
